export default {
  insertAllPurchaseYx: '/ygsjzs/purchaseYx/insertAllPurchaseYx',
  editPurchaseYx: '/ygsjzs/purchaseYx/editPurchaseYx',
  updatePurchaseYx: '/ygsjzs/purchaseYx/updatePurchaseYx',
  deleteDataPurchaseYx: '/ygsjzs/purchaseYx/deleteDataPurchaseYx',
  selectPurchaseYxByList: '/ygsjzs/purchaseYx/selectPurchaseYxByList'
}
